import { Box, ListItem, ListItemButton, ListItemIcon, List, ListItemText, Stack, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { IoIosArrowDown, IoIosArrowForward } from 'react-icons/io';
import { SidebarList, checkPermission } from '../../helper';

const Sidebar = ({ handleDrawerToggle, drawerStatus, activeSubMenu, setActiveSubMenu }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const userRole = localStorage.getItem("ROLE"); // Get current user's role

  const toggleSubMenu = (name) => {
    setActiveSubMenu(activeSubMenu === name ? null : name);
  };

  const isActive = (path, subPath = []) => {
    return location.pathname === path || subPath.includes(location.pathname);
  };

  const handleNavigation = (path) => {
    localStorage.removeItem("lastpage");
    navigate(path);
    if (path) {
      handleDrawerToggle();
    }
  };

  // Filter Sidebar Items Based on Permission
  const filteredSidebarList = SidebarList.filter((item) =>
    checkPermission(item.PermissionStatus, userRole)
  );

  const renderSubMenu = (subMenus) => {
    return subMenus
      .filter((subMenu) => checkPermission(subMenu.PermissionStatus, userRole)) // Filter Submenus
      .map((subMenu, index) => (
        <ListItem
          key={index}
          onClick={() => handleNavigation(subMenu.path)}
          disablePadding
          sx={{ my: "3px" }}
        >
          <ListItemButton
            sx={{
              gap: 1,
              p: "11px",
              justifyContent: "center",
              borderRadius: "6px",
              backgroundColor: location.pathname === subMenu.path ? "white.main" : "",
              background: location.pathname === subMenu.path ? "var(--primary) !important" : "transparent !important",
            }}
            className={location.pathname === subMenu.path ? "active_sidebar" : ""}
          >
            <ListItemIcon sx={{ minWidth: "unset" }}>
              {location.pathname === subMenu.path ? subMenu.activeIcon : subMenu.icon}
            </ListItemIcon>
            {drawerStatus && (
              <ListItemText
                primary={`${subMenu.name.slice(0, 15)}${subMenu.name.length > 15 ? "..." : ""}`}
                className="sidebar_text"
                sx={{
                  margin: "0",
                  transition: "width 0.3s ease-in-out",
                  textWrap: "nowrap",
                  color: location.pathname === subMenu.path ? "white.main" : "black.main",
                }}
              />
            )}
          </ListItemButton>
        </ListItem>
      ));
  };

  const renderListItems = (sidebarItem) => {
    const { name, icon, activeIcon, path, SUBMENU, subMenus } = sidebarItem;

    return (
      <List sx={{ padding: "0", my: "5px", mx: 1 }} key={name}>
        <ListItem disablePadding>
          <ListItemButton
            onClick={() => (SUBMENU ? toggleSubMenu(name) : handleNavigation(path))}
            sx={{
              gap: 1,
              p: "11px",
              justifyContent: "center",
              borderRadius: "6px",
              backgroundColor: location.pathname === path ? "white.main" : "",
              background: location.pathname === path ? "var(--primary) !important" : "transparent !important",
            }}
            className={location.pathname === path ? "active_sidebar" : ""}
          >
            <ListItemIcon sx={{ minWidth: "unset" }}>
              {location.pathname === path ? activeIcon : icon}
            </ListItemIcon>
            {drawerStatus && (
              <ListItemText
                primary={`${name.slice(0, 15)}${name.length > 15 ? "..." : ""}`}
                className="sidebar_text"
                sx={{ margin: "0", color: location.pathname === path ? "white.main" : "black.main" }}
              />
            )}
            {drawerStatus && SUBMENU && (
              activeSubMenu === name ? <IoIosArrowDown style={{ fontSize: "14px" }} /> : <IoIosArrowForward style={{ fontSize: "14px" }} />
            )}
          </ListItemButton>
        </ListItem>
        {SUBMENU && activeSubMenu === name && (
          <List sx={{ px: 1, py: 0 }}>{renderSubMenu(subMenus)}</List>
        )}
      </List>
    );
  };

  return (
    <Box sx={{ transition: "width 0.3s ease-in-out", height: "100vh" }}>
      <List sx={{ margin: "10px auto 0", display: "flex", justifyContent: "center" }}>
        {drawerStatus ? (
          <Typography className="logo">
            Home <span style={{ color: "var(--primary)" }}>Hancer</span>
          </Typography>
        ) : (
          <Typography className="logo">
            H<span style={{ color: "var(--primary)" }}>H</span>
          </Typography>
        )}
      </List>
      <Stack justifyContent={"space-between"} height={"calc(100% - 70px)"}>
        <Box marginTop={3}>
          {filteredSidebarList.map((sidebarItem) => renderListItems(sidebarItem))}
        </Box>
      </Stack>
    </Box>
  );
};

export default Sidebar;
